import React from 'react';
import { Card, CardContent } from './ui/card';
import { Clock, Headphones, Music, FileAudio2, Disc, Mic, Video, GraduationCap } from 'lucide-react';

const OtherServices = () => {
  const services = [
    {
      icon: Clock,
      title: "Location de studio",
      description: "Louez notre studio à l'heure ou à la journée pour vos sessions d'enregistrement en autonomie",
      price: "À partir de 40€/h"
    },
    {
      icon: Headphones,
      title: "Coaching vocal",
      description: "Perfectionnez votre technique vocale avec nos coachs expérimentés pour sublimer vos performances",
      price: "Sur devis"
    },
    {
      icon: Music,
      title: "Arrangement musical",
      description: "Création d'arrangements sur mesure pour enrichir et structurer vos compositions musicales",
      price: "Sur devis"
    },
    {
      icon: FileAudio2,
      title: "Restauration audio",
      description: "Nettoyage et restauration de vos enregistrements anciens ou endommagés (vinyles, cassettes, bandes)",
      price: "À partir de 80€"
    },
    {
      icon: Mic,
      title: "Doublage & Voice-over",
      description: "Enregistrement professionnel pour publicités, documentaires, livres audio et contenus audiovisuels",
      price: "À partir de 120€"
    },
    {
      icon: Disc,
      title: "Podcast recording",
      description: "Enregistrement et post-production complète pour vos podcasts avec équipement broadcast professionnel",
      price: "À partir de 150€"
    },
    {
      icon: Video,
      title: "Sound design vidéo",
      description: "Création sonore sur mesure pour vos projets vidéo, films, publicités et contenus multimédias",
      price: "Sur devis"
    },
    {
      icon: GraduationCap,
      title: "Formation audio",
      description: "Cours particuliers ou en groupe sur Pro Tools, Logic, Ableton et techniques d'enregistrement",
      price: "À partir de 60€/h"
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-white via-orange-50/20 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-orange-600 font-semibold text-sm uppercase tracking-wide">
            Autres Prestations
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-3 mb-4">
            Services complémentaires
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Découvrez notre gamme complète de prestations pour répondre à tous vos besoins audio et musicaux
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => {
            const IconComponent = service.icon;
            return (
              <Card
                key={index}
                className="group border-2 border-gray-100 hover:border-orange-500 transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
              >
                <CardContent className="p-6">
                  <div className="bg-orange-50 w-14 h-14 rounded-lg flex items-center justify-center mb-4 group-hover:bg-orange-600 transition-colors duration-300">
                    <IconComponent className="w-7 h-7 text-orange-600 group-hover:text-white transition-colors duration-300" />
                  </div>
                  
                  <h3 className="text-lg font-bold text-gray-900 mb-2">
                    {service.title}
                  </h3>
                  
                  <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                    {service.description}
                  </p>

                  <div className="pt-4 border-t border-gray-100">
                    <span className="text-orange-600 font-semibold text-sm">
                      {service.price}
                    </span>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Bottom Note */}
        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">
            Des prestations sur mesure adaptées à votre projet et votre budget
          </p>
          <p className="text-sm text-gray-500">
            Contactez-nous pour un devis personnalisé • Tarifs dégressifs pour les projets longue durée
          </p>
        </div>
      </div>
    </section>
  );
};

export default OtherServices;
